import { ThemeConfig } from "antd";
import { colors } from "shared/theme/color";

// Scoped theme for the blue (navy) primary buttons — the "+ Jadwal Baru" CTA and
// the create panel's "Simpan Jadwal". Wrap a Button in a ConfigProvider with
// this theme so it renders navy with navyDark on hover, instead of the ink fill.
export const navyButtonTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.navy,
    colorPrimaryHover: colors.navyDark,
    colorPrimaryActive: colors.navyDark,
  },
};
